function normalizeValue(value) {
  if (value === null || value === undefined) {
    return ''
  }

  const normalized = String(value).trim()
  return normalized
}

export function formatDoctorSpecialization(doctor) {
  if (!doctor || typeof doctor !== 'object') {
    return ''
  }

  const specialization = normalizeValue(
    doctor.specialization_name || doctor.specialization
  )
  const academicDegree = normalizeValue(doctor.academic_degree)
  const academicTitle = normalizeValue(doctor.academic_title)

  return [specialization, academicDegree, academicTitle]
    .filter(Boolean)
    .join(', ')
}
